<template>
    <div>
        <h4 v-if="this.data.title">{{ this.data.title }}</h4>
        <ReportFilterBadge :metadata="this.data.metadata" />
        <ul>
            <li v-for="item in this.data.report">
                <span v-html="item.label"></span>
                <ListReport v-if="item.children" :data="formatDataForRecursiveChildComponent(item.children)"></ListReport>
            </li>
        </ul>
    </div>
</template>

<script>
  import ReportFormatter from '@/services/report_formatter'
  import ReportFilterBadge from '@/components/elements/ReportFilterBadge'

  export default {
    name: 'ListReport',
    components: { ReportFilterBadge },
    props: ['data'],
    methods: {
      formatDataForRecursiveChildComponent (data) {
        return ReportFormatter.textual(data)
      }
    }
  }
</script>

<style scoped>
  h4, li {
    color: #333;
  }
  li {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// ListReport.vue?37959db2